import { configEnv } from '@libraries/config';

const seoConfig = {
  title: 'PERPACK',
  description: 'Aplikasi WMS Perpack',
  openGraph: {
    type: 'website',
    locale: 'id_ID',
    url: configEnv.baseUrl,
    siteName: 'perpack',
  },
  twitter: {
    handle: '@perpack',
    site: '@perpack',
    cardType: 'summary_large_image',
  },
};

export default seoConfig;
